/*
 * Marc Ellis custom JS — MK redesign
 *
 * - Hamburger desktop binding (theme.js bina solo il primo data-drawer-toggle)
 * - Wishlist MVP localStorage (cuore header + product card)
 */

(function () {
  'use strict';

  // ============================================================
  // 1) HAMBURGER DESKTOP fix
  // ============================================================
  function bindDesktopHamburger() {
    document.querySelectorAll('.header__desktop__hamburger').forEach((btn) => {
      if (btn.dataset.mkBound === '1') return;
      btn.dataset.mkBound = '1';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const drawer = document.querySelector('[data-drawer]');
        if (drawer) drawer.dispatchEvent(new CustomEvent('theme:drawer:toggle'));
      });
    });
  }

  // ============================================================
  // 2) WISHLIST — MVP localStorage based
  // ============================================================
  const WISHLIST_KEY = 'mk_wishlist_v1';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }
  function setWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    updateHeaderCount();
  }
  function toggleProduct(productId) {
    const list = getWishlist();
    const idx = list.indexOf(productId);
    if (idx >= 0) list.splice(idx, 1);
    else list.push(productId);
    setWishlist(list);
    return idx < 0; // true if added
  }

  // SVG cuore: fill/stroke gestiti via CSS (per supportare lo stato attivo riempito rosa)
  const HEART_SVG_OUTLINE = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

  // 2a) Inject heart on each product card (selettori reali Broadcast: .grid-item.product-item)
  function injectProductCardHearts() {
    const cards = document.querySelectorAll('.product-item, .grid-item.product-item, .product-grid-item');
    cards.forEach((card) => {
      if (card.dataset.mkHeart === '1') return;
      // Trova il product id (gli element Shopify usano data-product-id, data-id, o link al prodotto)
      let productId =
        card.getAttribute('data-product-id') ||
        card.getAttribute('data-id') ||
        (card.querySelector('a[href*="/products/"]')?.getAttribute('href')?.match(/\/products\/([^/?#]+)/) || [])[1];
      if (!productId) return;
      card.dataset.mkHeart = '1';
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mk-wishlist-toggle';
      btn.setAttribute('aria-label', 'Aggiungi ai preferiti');
      btn.innerHTML = HEART_SVG_OUTLINE;
      btn.dataset.productId = productId;
      if (getWishlist().includes(productId)) btn.classList.add('is-active');
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const added = toggleProduct(productId);
        btn.classList.toggle('is-active', added);
        pulseHeart(btn);
        if (added) flyHeartToHeader(btn);
      });
      card.appendChild(btn);
    });
  }

  // 2b) Inject heart link nell'header (accanto al cart) — un solo container
  function injectHeaderHeart() {
    const container =
      document.querySelector('.header__desktop__bar__r .header__desktop__buttons') ||
      document.querySelector('.header__desktop__bar__r');
    if (!container) return;
    if (container.dataset.mkHeaderHeart === '1') return;
    // rimuovi eventuali heart già presenti in container PADRI o FIGLI (cleanup duplicati)
    document
      .querySelectorAll('.header__desktop__bar__r .mk-wishlist-link')
      .forEach((el) => el.remove());
    container.dataset.mkHeaderHeart = '1';
    const link = document.createElement('a');
    link.className = 'mk-wishlist-link';
    link.href = '/pages/wishlist';
    link.setAttribute('aria-label', 'Preferiti');
    link.innerHTML = HEART_SVG_OUTLINE;
    const cart = container.querySelector('[href*="/cart"], .header__cart, .header__desktop__cart');
    if (cart && cart.parentElement === container) {
      container.insertBefore(link, cart);
    } else {
      container.appendChild(link);
    }
    updateHeaderCount();
  }

  function updateHeaderCount() {
    const count = getWishlist().length;
    // Header link: fill rosa quando count > 0 (MK style, no badge)
    document.querySelectorAll('.mk-wishlist-link').forEach((el) => {
      el.classList.toggle('is-active', count > 0);
    });
    // Drawer: count testuale (più informativo nel context lista)
    document.querySelectorAll('[data-mk-drawer-count]').forEach((el) => {
      if (count > 0) {
        el.textContent = String(count);
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    });
  }

  // ============================================================
  // 3) WISHLIST PAGE rendering (su /pages/wishlist)
  // ============================================================
  async function renderWishlistPage() {
    const root = document.querySelector('[data-mk-wishlist-root]');
    if (!root) return;

    const empty = root.querySelector('[data-mk-wishlist-empty]');
    const itemsEl = root.querySelector('[data-mk-wishlist-items]');
    const countEl = root.querySelector('[data-mk-wishlist-count]');
    const loadingEl = root.querySelector('[data-mk-wishlist-loading]');

    const list = getWishlist();
    if (countEl) countEl.textContent = list.length;

    if (list.length === 0) {
      empty.hidden = false;
      itemsEl.hidden = true;
      return;
    }

    empty.hidden = true;
    if (loadingEl) loadingEl.hidden = false;

    // Fetch parallelo dei prodotti via endpoint JSON pubblico Shopify
    const products = await Promise.all(
      list.map(async (handle) => {
        try {
          const res = await fetch(`/products/${handle}.js`);
          if (!res.ok) return null;
          return await res.json();
        } catch (e) {
          return null;
        }
      })
    );

    if (loadingEl) loadingEl.hidden = true;

    const html = products
      .filter(Boolean)
      .map((p) => {
        const img = (p.featured_image || '').replace(/^\/\//, 'https://');
        const price = (p.price / 100).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
        return `<div class="mk-wishlist-card" data-handle="${p.handle}">
          <a href="/products/${p.handle}">
            <div class="mk-wishlist-card__image" style="background-image:url('${img}')"></div>
          </a>
          <button type="button" class="mk-wishlist-card__remove" aria-label="Rimuovi" data-remove="${p.handle}">×</button>
          <div class="mk-wishlist-card__body">
            <h3 class="mk-wishlist-card__title"><a href="/products/${p.handle}">${p.title}</a></h3>
            <span class="mk-wishlist-card__price">${price}</span>
          </div>
        </div>`;
      })
      .join('');

    itemsEl.innerHTML = html;
    itemsEl.hidden = false;

    // Bind rimozione
    itemsEl.querySelectorAll('[data-remove]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const handle = btn.dataset.remove;
        const newList = getWishlist().filter((h) => h !== handle);
        setWishlist(newList);
        renderWishlistPage();
      });
    });
  }

  // 2d) Inject heart button nella PDP gallery (top-right sopra l'immagine)
  function injectPdpWishlist() {
    if (!document.body.classList.contains('template-product')) return;
    const gallery =
      document.querySelector('product-images') ||
      document.querySelector('.product__images');
    if (!gallery || gallery.dataset.mkPdpHeart === '1') return;
    const match = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    const productId = match[1];
    gallery.dataset.mkPdpHeart = '1';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mk-pdp-wishlist';
    btn.setAttribute('aria-label', 'Aggiungi ai preferiti');
    btn.dataset.productId = productId;
    btn.innerHTML = HEART_SVG_OUTLINE;
    if (getWishlist().includes(productId)) btn.classList.add('is-active');
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const added = toggleProduct(productId);
      btn.classList.toggle('is-active', added);
      pulseHeart(btn);
    });
    gallery.appendChild(btn);
  }

  // 2c) Inject voce "WISHLIST" nel drawer mobile-menu
  function injectDrawerWishlist() {
    const drawer = document.querySelector('.mobile-menu');
    if (!drawer || drawer.dataset.mkDrawerWl === '1') return;
    drawer.dataset.mkDrawerWl = '1';
    const link = document.createElement('a');
    link.href = '/pages/wishlist';
    link.className = 'mk-drawer-wishlist';
    link.innerHTML =
      HEART_SVG_OUTLINE +
      '<span class="mk-drawer-wishlist__label">WISHLIST</span>' +
      '<span class="mk-drawer-wishlist__count" data-mk-drawer-count></span>';
    // Inserisci dopo il blocco menu principale, prima di socials/localization
    const menuBlock = drawer.querySelector('.mobile-menu__block--menu');
    if (menuBlock && menuBlock.parentElement) {
      menuBlock.parentElement.insertBefore(link, menuBlock.nextSibling);
    } else {
      drawer.appendChild(link);
    }
    updateHeaderCount();
  }

  // ============================================================
  // 4) EDITORIAL SPLIT — overlay centrato tra le 2 immagini (MK "Natural Touch")
  // ============================================================
  function injectEditorialOverlay() {
    const sections = document.querySelectorAll(
      '.shopify-section [data-section-type="custom-content"], [data-section-type="custom-content"]'
    );
    sections.forEach((sec) => {
      if (sec.dataset.mkOverlay === '1') return;
      const brick = sec.querySelector('.brick__section');
      if (!brick) return;
      const blocks = brick.querySelectorAll('.brick__block');
      if (blocks.length < 2) return;
      sec.dataset.mkOverlay = '1';
      brick.style.position = 'relative';
      const overlay = document.createElement('div');
      overlay.className = 'mk-editorial-overlay';
      overlay.innerHTML =
        '<div class="mk-editorial-overlay__sub">MARC ELLIS</div>' +
        '<h2 class="mk-editorial-overlay__title">TIMELESS ELEGANCE</h2>' +
        '<p class="mk-editorial-overlay__text">Borse iconiche e dettagli sartoriali per ogni momento della tua giornata.</p>' +
        '<a class="mk-editorial-overlay__cta" href="/collections/all">SCOPRI ORA</a>';
      brick.appendChild(overlay);
    });
  }

  // ============================================================
  // 5) SCROLL REVEAL — sezioni in entrata con fade-up
  // ============================================================
  function initScrollReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const sections = document.querySelectorAll('.main-content > .shopify-section');
    if (!sections.length || !('IntersectionObserver' in window)) return;

    sections.forEach((s) => {
      const rect = s.getBoundingClientRect();
      // Se già in viewport al load, niente reveal (evita flash)
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        s.classList.add('mk-reveal', 'mk-reveal--visible');
      } else {
        s.classList.add('mk-reveal');
      }
    });

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('mk-reveal--visible');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -60px 0px' }
    );
    sections.forEach((s) => {
      if (!s.classList.contains('mk-reveal--visible')) obs.observe(s);
    });
  }

  // ============================================================
  // 6) HEART PULSE — micro-animazione click cuore
  // ============================================================
  function pulseHeart(btn) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    btn.classList.remove('mk-heart-pulse');
    void btn.offsetWidth;
    btn.classList.add('mk-heart-pulse');
  }

  // ============================================================
  // 7) CAROUSEL HEADING — aggiunge subheading "italic editorial" sopra l'heading
  // per stupire visivamente. Marca la sezione con class .mk-rich-heading per CSS.
  // ============================================================
  // ============================================================
  // HEADINGS TEXT WOW — lettere entrano dal basso una alla volta (cascade)
  // ============================================================
  function initHeadingsTextReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    if (!document.body.classList.contains('template-index')) return;

    const selectors = [
      '.mk-rich-heading .heading',
      '.mk-rich-heading h2',
      '.mk-editorial-3col__title',
    ];
    const headings = document.querySelectorAll(selectors.join(','));
    headings.forEach((h) => {
      if (h.dataset.mkLettersSplit === '1') return;
      h.dataset.mkLettersSplit = '1';
      const text = h.textContent.trim();
      const words = text.split(/\s+/);
      h.innerHTML = '';
      let letterIndex = 0;
      words.forEach((word, wi) => {
        // wrappa la parola in uno span che non va a capo a metà
        const wordSpan = document.createElement('span');
        wordSpan.className = 'mk-lw';
        for (const ch of word) {
          const letterSpan = document.createElement('span');
          letterSpan.className = 'mk-letter';
          letterSpan.style.setProperty('--mk-l-i', letterIndex);
          letterSpan.textContent = ch;
          wordSpan.appendChild(letterSpan);
          letterIndex += 1;
        }
        h.appendChild(wordSpan);
        if (wi < words.length - 1) h.appendChild(document.createTextNode(' '));
      });
      h.classList.add('mk-letters-split');
    });

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('mk-letters-split--in');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.3, rootMargin: '0px 0px -30px 0px' }
    );
    document.querySelectorAll('.mk-letters-split').forEach((el) => obs.observe(el));
  }

  // ============================================================
  // CATEGORY TILE REVEAL — wipe-up cinematografico per i 4 tile categorie (columns-1)
  // ============================================================
  function initCategoryTilesReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    if (!document.body.classList.contains('template-index')) return;

    // Trova le sezioni .section-columns sulla home e applica la reveal speciale
    const sections = document.querySelectorAll('.template-index .section-columns');
    sections.forEach((sec) => {
      const items = sec.querySelectorAll('.columns__item');
      if (!items.length) return;
      items.forEach((item, idx) => {
        if (item.dataset.mkCatReveal === '1') return;
        item.dataset.mkCatReveal = '1';
        item.classList.add('mk-cat-reveal');
        item.style.setProperty('--mk-cat-i', idx);
      });
    });

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('mk-cat-reveal--in');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -50px 0px' }
    );
    document.querySelectorAll('.mk-cat-reveal').forEach((el) => obs.observe(el));
  }

  // ============================================================
  // SECTION DIVIDER — stella signature + 2 linee fini animate su scroll
  // ============================================================
  function injectSectionDividers() {
    if (!document.body.classList.contains('template-index')) return;
    const STAR_SVG = '';

    const targets = document.querySelectorAll(
      '.main-content > .shopify-section.shopify-section--section-collection,' +
      '.main-content > .shopify-section.shopify-section--section-columns,' +
      '.main-content > .shopify-section.shopify-section--section-custom-code'
    );

    // Fallback: cerca tutte le section-collection e section-custom-code per tag/data-section-type
    let sections = targets.length
      ? Array.from(targets)
      : Array.from(document.querySelectorAll('.main-content > .shopify-section'))
          .filter((s) =>
            s.querySelector(
              '.grid--slider, .section-columns, .mk-editorial-3col, [data-section-type="collection"]'
            )
          );

    sections.forEach((sec, idx) => {
      if (idx === 0) return; // skip primo (subito sotto hero)
      if (sec.previousElementSibling && sec.previousElementSibling.classList.contains('mk-divider')) return;
      if (sec.dataset.mkDivider === '1') return;
      sec.dataset.mkDivider = '1';
      const div = document.createElement('div');
      div.className = 'mk-divider';
      div.setAttribute('aria-hidden', 'true');
      div.innerHTML =
        '<span class="mk-divider__bar mk-divider__bar--black"></span>' +
        '<span class="mk-divider__bar mk-divider__bar--pink"></span>';
      sec.parentNode.insertBefore(div, sec);

      // Anim on scroll: aggiunge .is-visible quando in viewport
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
        const obs = new IntersectionObserver(
          (entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                e.target.classList.add('mk-divider--in');
                obs.unobserve(e.target);
              }
            });
          },
          { threshold: 0.4 }
        );
        obs.observe(div);
      } else {
        div.classList.add('mk-divider--in');
      }
    });
  }

  function injectCarouselHeadings() {
    if (!document.body.classList.contains('template-index')) return;
    // Applica solo la class .mk-rich-heading per attivare lo styling CSS (font, linea sottile)
    // Niente subheading injection per layout più compatto.
    const validKeys = ['new in', 'total look', 'style your feet', 'i più amati'];
    const sections = document.querySelectorAll('.main-content > .shopify-section');
    sections.forEach((sec) => {
      const holder = sec.querySelector('.grid__heading-holder');
      const headingEl = sec.querySelector('.grid__heading-text .heading, .grid__heading-text h2');
      if (!holder || !headingEl || holder.dataset.mkRich === '1') return;
      const key = headingEl.textContent.trim().toLowerCase();
      if (!validKeys.includes(key)) return;
      holder.dataset.mkRich = '1';
      holder.classList.add('mk-rich-heading');
    });
  }

  // (Legacy intro slide kept for backwards compatibility but not called)
  function injectCarouselIntroSlide() {
    if (!document.body.classList.contains('template-index')) return;

    const imageMap = {
      'new in':            'https://cdn.shopify.com/s/files/1/0894/5182/3434/files/24-intro-new-in.jpg',
      'total look':        'https://cdn.shopify.com/s/files/1/0894/5182/3434/files/25-intro-total-look.jpg',
      'style your feet':   'https://cdn.shopify.com/s/files/1/0894/5182/3434/files/26-intro-style-feet.jpg',
      'i più amati':       'https://cdn.shopify.com/s/files/1/0894/5182/3434/files/27-intro-piu-amati.jpg',
    };

    const sections = document.querySelectorAll('.main-content > .shopify-section');
    sections.forEach((sec) => {
      const slider = sec.querySelector('.grid--slider');
      if (!slider || slider.dataset.mkIntro === '1') return;

      // Heading + description + CTA dall'header sopra il slider
      const headingEl = sec.querySelector('.grid__heading-text .heading, .grid__heading-text h2, h2');
      if (!headingEl) return;
      const headingText = headingEl.textContent.trim();
      const key = headingText.toLowerCase();
      const img = imageMap[key];
      if (!img) return;

      const descEl = sec.querySelector('.grid__heading-text .rte, .grid__heading-text p');
      const desc = descEl ? descEl.innerHTML : '';
      const ctaEl = sec.querySelector('.grid__heading-holder .btn, .grid__heading-text + * .btn, .grid__heading-text ~ .btn');
      const ctaHref = ctaEl ? ctaEl.getAttribute('href') : '#';
      const ctaText = ctaEl ? ctaEl.textContent.trim() : 'VEDI I PRODOTTI';

      slider.dataset.mkIntro = '1';

      // Crea la intro slide come grid-item (matcha le dimensioni delle altre card)
      const intro = document.createElement('div');
      intro.className = 'grid-item product-item mk-intro-slide';
      intro.innerHTML =
        '<div class="mk-intro-slide__inner">' +
          '<div class="mk-intro-slide__img" style="background-image:url(\'' + img + '\')"></div>' +
          '<div class="mk-intro-slide__body">' +
            '<h2 class="mk-intro-slide__title">' + headingText + '</h2>' +
            (desc ? '<div class="mk-intro-slide__desc">' + desc + '</div>' : '') +
            '<a class="mk-intro-slide__cta" href="' + ctaHref + '">' + ctaText + '</a>' +
          '</div>' +
        '</div>';

      slider.insertBefore(intro, slider.firstChild);

      // Nasconde l'header sopra (heading + desc + cta originali) — info ora vivono nella intro slide
      const holder = sec.querySelector('.grid__heading-holder');
      if (holder) holder.classList.add('mk-heading-hidden');
    });
  }

  // ============================================================
  // 8) MARQUEE — signature brand ribbon tra hero e tile (template-index)
  // ============================================================
  function injectMarquee() {
    if (!document.body.classList.contains('template-index')) return;
    if (document.querySelector('.mk-marquee')) return;
    const heroSection = document.querySelector('.main-content > .shopify-section.section-overlay-header')
      || document.querySelector('.main-content > .shopify-section');
    if (!heroSection) return;
    const phrase = 'MARC ELLIS · ICONIC ELEGANCE · NEW IN · MARC ELLIS · ICONIC ELEGANCE · NEW IN · ';
    // Replico 2 volte la phrase per loop seamless
    const marquee = document.createElement('div');
    marquee.className = 'mk-marquee';
    marquee.setAttribute('aria-hidden', 'true');
    marquee.innerHTML =
      '<div class="mk-marquee__track">' +
      '<span class="mk-marquee__chunk">' + phrase + '</span>' +
      '<span class="mk-marquee__chunk">' + phrase + '</span>' +
      '</div>';
    heroSection.parentNode.insertBefore(marquee, heroSection.nextSibling);
  }

  // ============================================================
  // 8) STAGGER REVEAL — tile / product card entrano con delay incrementale
  // ============================================================
  function initStaggerReveal() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    const groups = document.querySelectorAll(
      '.section-columns .grid, .grid--slider, .grid--mobile-vertical'
    );
    groups.forEach((group) => {
      const items = group.querySelectorAll('.columns__item, .grid-item, .product-item');
      items.forEach((item, idx) => {
        item.style.setProperty('--mk-i', idx);
        item.classList.add('mk-stagger');
      });
    });
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('mk-stagger--visible');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -40px 0px' }
    );
    document.querySelectorAll('.mk-stagger').forEach((el) => obs.observe(el));
  }

  // ============================================================
  // 9) IMAGE FADE-IN — ogni img entra in viewport con fade dolce
  // ============================================================
  function initImageFadeIn() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    const imgs = document.querySelectorAll('img:not(.mk-fade-init)');
    if (!imgs.length) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('mk-img-loaded');
            obs.unobserve(e.target);
          }
        });
      },
      { rootMargin: '100px 0px' }
    );
    imgs.forEach((img) => {
      img.classList.add('mk-fade-init');
      // se già caricata (cached), apply immediatamente
      if (img.complete && img.naturalHeight !== 0) {
        img.classList.add('mk-img-loaded');
      } else {
        img.addEventListener('load', () => img.classList.add('mk-img-loaded'), { once: true });
        obs.observe(img);
      }
    });
  }

  // ============================================================
  // 10) SCROLL INDICATOR hero — freccia che pulsa, sparisce al primo scroll
  // ============================================================
  function injectScrollIndicator() {
    if (!document.body.classList.contains('template-index')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.innerWidth < 750) return; // skip mobile
    const hero = document.querySelector('.main-content > .shopify-section.section-overlay-header');
    if (!hero || hero.querySelector('.mk-scroll-indicator')) return;
    const ind = document.createElement('div');
    ind.className = 'mk-scroll-indicator';
    ind.setAttribute('aria-hidden', 'true');
    ind.innerHTML = '<span class="mk-scroll-indicator__line"></span><span class="mk-scroll-indicator__label">SCROLL</span>';
    hero.appendChild(ind);
    const dismiss = () => {
      ind.classList.add('mk-scroll-indicator--gone');
      window.removeEventListener('scroll', dismiss);
    };
    window.addEventListener('scroll', dismiss, { passive: true, once: true });
  }

  // ============================================================
  // 11) HEART FLY — micro animation: cuore che vola dalla card al header heart
  // ============================================================
  function flyHeartToHeader(originBtn) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const target = document.querySelector('.mk-wishlist-link');
    if (!target) return;
    const startRect = originBtn.getBoundingClientRect();
    const endRect = target.getBoundingClientRect();
    const ghost = document.createElement('div');
    ghost.className = 'mk-heart-fly';
    ghost.innerHTML = HEART_SVG_OUTLINE;
    ghost.style.left = startRect.left + startRect.width / 2 + 'px';
    ghost.style.top = startRect.top + startRect.height / 2 + 'px';
    document.body.appendChild(ghost);
    const dx = endRect.left + endRect.width / 2 - (startRect.left + startRect.width / 2);
    const dy = endRect.top + endRect.height / 2 - (startRect.top + startRect.height / 2);
    requestAnimationFrame(() => {
      ghost.style.transform = `translate(${dx}px, ${dy}px) scale(0.4)`;
      ghost.style.opacity = '0';
    });
    setTimeout(() => {
      ghost.remove();
      pulseHeart(target);
    }, 700);
  }

  // ============================================================
  // BOOTSTRAP
  // ============================================================
  function init() {
    // Cleanup eventuali marquee / scroll-indicator iniettati da versioni precedenti
    document.querySelectorAll('.mk-marquee, .mk-scroll-indicator').forEach((el) => el.remove());

    bindDesktopHamburger();
    injectHeaderHeart();
    injectDrawerWishlist();
    injectProductCardHearts();
    injectPdpWishlist();
    renderWishlistPage();
    initScrollReveal();
    initStaggerReveal();
    initImageFadeIn();
    injectCarouselHeadings();
    injectSectionDividers();
    initCategoryTilesReveal();
    initHeadingsTextReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-injection quando il DOM cambia (es. carousel lazy-load, AJAX cart, drawer dynamic)
  const observer = new MutationObserver(() => {
    injectProductCardHearts();
    injectDrawerWishlist();
    injectPdpWishlist();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
